import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { isEmpty } from "lodash"

import InputField from "components/input"
import SubmitNotification from "components/common/submit-notification"

import { validateEmail, validateNumber } from "helpers/regex-validator"
import { AUTH_TYPES, AUTH_SUCCESS } from "constants/auth-types"
import { GOOGLE_SITE_KEY } from "constants/config"
import Facebook from "./facebookLogin"
import Google from "./googleLoginForm"
import { registerUser, resendEmail, showAuthModal } from "store/auth/action"

import SendIcon from "assets/icons/send.svg"

import "styles/components/auth/auth.scss"
import Button from "../common/Button"

export class Signup extends Component {
  constructor() {
    super()

    this.state = {
      registrationForm: {
        username: "",
        email: "",
        password1: "",
        password2: "",
      },
      fieldErrors: {},
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      auth: { errors },
    } = this.props

    const {
      auth: { errors: prevErrors },
    } = prevProps

    if (errors !== prevErrors) {
      this.setState({ fieldErrors: errors })
    }
  }

  handleChange = (e) => {
    const { registrationForm } = this.state
    const { name, value } = e.currentTarget

    this.setState(
      {
        registrationForm: {
          ...registrationForm,
          [name]: value,
        },
      },
      () => {
        this.validateField(name)
      }
    )
  }

  validateField = (fieldName) => {
    let fieldErrors = this.state.fieldErrors

    //add more validations
    if (isEmpty(fieldErrors[fieldName])) {
      fieldErrors.fieldName = "This field is required"
    } else {
      delete fieldErrors[fieldName]
    }
    this.setState({ fieldErrors })
  }

  handleRegister = (e) => {
    e.preventDefault()

    const {
      school: { schoolData },
      registerUser,
    } = this.props
    const { registrationForm } = this.state

    const { error } = this.validateOnSubmit(registrationForm)

    if (!isEmpty(error)) {
      this.setState({ fieldErrors: error })
    } else {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(GOOGLE_SITE_KEY, { action: "submit" })
          .then((token) => {
            registrationForm["g-recaptcha-response"] = token
            registrationForm["school"] = schoolData.id
            registerUser(registrationForm)
          })
      })
    }
  }

  handleResendEmail = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(GOOGLE_SITE_KEY, { action: "submit" })
        .then((token) => {
          this.props.resendEmail({
            "g-recaptcha-response": token,
          })
        })
    })
  }

  validateOnSubmit(values) {
    const error = {}

    if (!values.username) {
      error.username = "Username is required"
    }

    if (!values.email) {
      error.email = "Email Address is required"
    } else if (!validateEmail(values.email)) {
      error.email = "Invalid Email Address"
    }

    if (!values.password1) {
      error.password1 = "Password is required"
    } else if (values.password1.length < 8) {
      error.password1 = "Password must contain atleast 8 characters."
    } else if (validateNumber(values.password1)) {
      error.password1 = "Password must contain letters and numbers."
    }

    if (!values.password2) {
      error.password2 = "Password is required"
    }

    if (
      values.password1 &&
      values.password2 &&
      values.password1 !== values.password2
    ) {
      error.password2 = "Password not match."
    }

    return { error }
  }

  render() {
    const { registrationForm, fieldErrors } = this.state

    const {
      auth: { authModal, errors, isLoading },
      school: { schoolData },
      showAuthModal,
    } = this.props

    const isFacebookEnabled = schoolData?.config?.products?.facebook_sso
    const isGoogleEnabled = schoolData?.config?.products?.google_sso
    return (
      <>
        {authModal.successType === AUTH_SUCCESS.REGISTER ? (
          <>
            <div className="upper-container">
              <figure className="image">
                <img src={SendIcon} alt="send" className="send-icon" />
              </figure>
              <h1 className="headline">You're almost there!</h1>
              <SubmitNotification
                type={errors && errors.error && "FAILED"}
                message={errors && errors.error}
              />
              <p className="description">Don't forget to verify your email</p>
              <p className="email">{registrationForm.email}</p>
            </div>
            <div className="bottom-container">
              <p className="text">
                Didn't get an email? Click
                <span className="resend-link" onClick={this.handleResendEmail}>
                  {" "}
                  here{" "}
                </span>
                to resend email verification or contact us at{" "}
                <span className="email">admin@apptitude.xyz</span>
              </p>
            </div>
          </>
        ) : (
          <>
            <form className="login-details" onSubmit={this.handleRegister}>
              <h1 className="title">Create an account</h1>
              <h3 className="subtitle">Build your skills today, online!</h3>
              <SubmitNotification
                type={
                  errors &&
                  (errors.non_field_errors || errors.message) &&
                  "FAILED"
                }
                message={errors && (errors.non_field_errors || errors.message)}
              />
              <InputField
                label="Username"
                name="username"
                required={true}
                value={registrationForm["username"]}
                error={fieldErrors["username"]}
                onChange={this.handleChange}
              />
              <InputField
                label="Email"
                name="email"
                required={true}
                value={registrationForm["email"]}
                error={fieldErrors["email"]}
                onChange={this.handleChange}
              />
              <InputField
                label="Password"
                name="password1"
                required={true}
                type="password"
                value={registrationForm["password1"]}
                error={fieldErrors["password1"]}
                onChange={this.handleChange}
              />
              <InputField
                label="Confirm Password"
                name="password2"
                required={true}
                type="password"
                value={registrationForm["password2"]}
                error={fieldErrors["password2"]}
                onChange={this.handleChange}
              />
              <Button
                label="Create Account"
                type="submit"
                block
                size="medium"
                loading={isLoading}
                customClassName={"auth-button"}
              />
            </form>
            {(isFacebookEnabled || isGoogleEnabled) && (
              <div className="login-option">or sign up with</div>
            )}
            <div className="login-buttons">
              {isFacebookEnabled && <Facebook type={AUTH_TYPES.REGISTER} />}
              {isGoogleEnabled && <Google type={AUTH_TYPES.REGISTER} />}
            </div>
            <p className="agreement">
              By signing up, you agree to our{" "}
              <a
                href="https://apptitude.xyz/terms-and-conditions/"
                target="_blank"
                rel="noreferrer"
              >
                <span className="link">Terms of Use</span>
              </a>{" "}
              and{" "}
              <a
                href="https://apptitude.xyz/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                <span className="link">Privacy Policy</span>
              </a>
              .
            </p>
            <div className="row bottom-container">
              <div className="meta-links">
                <p
                  className="link"
                  onClick={() => showAuthModal({ type: AUTH_TYPES.LOGIN })}
                >
                  Already have an account?
                </p>
              </div>
            </div>
          </>
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      registerUser,
      resendEmail,
      showAuthModal,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(Signup)
